export default __webpack_public_path__ + "static/media/barfooter.e9df6a8e.png";